import * as React from 'react'

import { Theme, useTheme } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'

const getStyles = (theme: Theme) => ({
  button: {
    width: '100%',
  },

  alert: {
    marginTop: theme.spacing(1),
    alignItems: 'center',
    paddingTop: (theme: Theme) => theme.spacing(0),
    paddingBottom: (theme: Theme) => theme.spacing(0),
  },

  alertLabel: {
    fontFamily: 'Source Sans Pro SemiBold',
  },
})

type Props = {
  onClick: () => void
  disabled: boolean
  isInvalid: boolean
  branch: string
}

export const EditCardFooter: React.FC<Props> = (props) => {
  const { onClick, disabled, isInvalid, branch } = props
  const styles = getStyles(useTheme())
  return (
    <Box mt={1}>
      <Button
        onClick={onClick}
        variant="outlined"
        color="primary"
        disabled={disabled}
        sx={styles.button}
        data-test-id="editCardFooterBtn"
      >
        Edit
      </Button>
      {isInvalid ? (
        <Alert severity="warning" sx={styles.alert}>
          Required fields missing
          <br />
          <Typography sx={styles.alertLabel}>ADD REQUIRED FIELDS</Typography>
        </Alert>
      ) : (
        <Alert severity="info" sx={styles.alert}>
          <Typography>
            A new location will be created in the following branch:{' '}
            <Typography component="span" sx={styles.alertLabel}>
              {branch}
            </Typography>
          </Typography>
        </Alert>
      )}
    </Box>
  )
}
EditCardFooter.displayName = 'EditCardFooter'
